import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt, faQuestionCircle, faCog } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';
import AdminAccountSelector from './AdminAccountSelector';

function Header({ theme, handleLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const { currentUser } = useAuth();  
  const isAdmin = currentUser && currentUser.isAdmin;
  const isContractAdmin = currentUser && currentUser.isContractAdmin;
  const isPolicyAdmin = currentUser && currentUser.isPolicyAdmin;

  const policies = useSelector((state) => state.policies.activePolicies);
  const cardGroups = useSelector((state) => state.policies.cardGroups);
  const policiesStatus = useSelector((state) => state.policies.status);  
  const [selectedPolicy, setSelectedPolicy] = useState(currentUser ? currentUser.policyNumber : null);
  const [selectedCardGroup, setSelectedCardGroup] = useState(currentUser ? currentUser.cardGroupID : null);

  const apiUrl = process.env.REACT_APP_API_URL;

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    // Skip this logic for affiliate users who don't need policy/card group selection
    if (currentUser && !(currentUser.isAffiliate === 'True' || currentUser.isAffiliate === true || currentUser.Roles === 'Affiliate')) {
      if (currentUser.cardGroupID) {
        setSelectedCardGroup(currentUser.cardGroupID);
        setSelectedPolicy(null);
      } else {
        setSelectedPolicy(currentUser.policyNumber || "");
        setSelectedCardGroup(null);
      }
    }
  }, [currentUser?.policyNumber, currentUser?.cardGroupID, currentUser?.isAffiliate]);

  const handleAccountSelection = async (selection) => {
    const { value, selectedPolicy, selectedCardGroup } = selection;

    const policyNumber = selectedPolicy ? selectedPolicy.PolicyNumber : (selectedCardGroup ? selectedCardGroup.PolicyNumber : null);
    const cardGroupID = selectedCardGroup ? selectedCardGroup.cardGroupID : null;

    if (!policyNumber && !cardGroupID) {
      console.error('No valid policy number or card group selected');
      return;
    }

    setSelectedPolicy(policyNumber);
    setSelectedCardGroup(cardGroupID);

    try {
        const response = await fetch(`${apiUrl}/dataServer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                action: 'updateAdminPolicyAndCardGroup',
                payload: {
                    userId: currentUser.userId,
                    selectedPolicy: policyNumber,
                    selectedCardGroup: cardGroupID,
                },
            }),
        });

        if (response.ok) {
            window.location.reload();
        } else {
            console.error('Failed to update Policy Number');
        }
    } catch (error) {
        console.error('An error occurred:', error);
    }
  };

  return (
    <div className="hidden xl:flex justify-between items-center p-4" style={{
      boxShadow: '4px 0px 4px rgba(0, 0, 0, 0.1)',
      backgroundColor: theme.sidebarBg || '#ffffff',
      zIndex: 2
    }}>
      <div className="text-2xl font-bold" style={{ color: theme.menuText }}>
{(isAdmin || isContractAdmin || isPolicyAdmin) && !currentUser?.isAffiliate ? (
          <div className="min-w-0 flex-1 max-w-lg relative">
            <AdminAccountSelector
              policies={policies}
              cardGroups={cardGroups}
              selectedValue={selectedCardGroup ? cardGroups.find(group => group.cardGroupID === selectedCardGroup)?.AccountNumber : selectedPolicy}
              onSelectionChange={handleAccountSelection}
              currentUser={currentUser}
              theme={theme}
              isMobile={false}
              disabled={!(policies.length > 0 || cardGroups.length > 0)}
              isLoading={currentUser && policiesStatus === 'loading'}
            />
          </div>
        ) : (
          currentUser ? currentUser.companyName : ""
        )}
      </div>

      <div className="relative">
        <FontAwesomeIcon 
          icon={faBars} 
          onClick={toggleMenu} 
          className="text-lg cursor-pointer" 
          style={{ color: theme.hamburgerMenuColor || '#000000' }}
        />
        {menuOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg">
            <ul>
              <li className="cursor-pointer hover:bg-gray-200 p-2">
                <Link to="/faq" className="flex items-center" onClick={() => setMenuOpen(false)}>
                  <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
                  FAQ
                </Link>
              </li>
              <li className="cursor-pointer hover:bg-gray-200 p-2">
                <Link to="/settings" className="flex items-center" onClick={() => setMenuOpen(false)}>
                  <FontAwesomeIcon icon={faCog} className="mr-2" />
                  Settings
                </Link>
              </li>
              <li className="cursor-pointer hover:bg-gray-200 p-2" onClick={() => { handleLogout(); setMenuOpen(false); }}>
                <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                Logout
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
